module.exports = __webpack_public_path__ + "img/mk-化学@2x.ec673251.png";